import { ofType } from 'redux-observable';

import { tap, mapTo } from 'rxjs/operators';

import { RESET_ACCOUNT_PASSWORD_SUCCESS, LOG_OUT } from '../../constants';

import { deleteCredentials } from '../../../utilities/localStorage';
import { pushRoute } from '../../../utilities/helpers';

const resetPasswordSuccess = action$ =>
  action$.pipe(
    ofType(RESET_ACCOUNT_PASSWORD_SUCCESS),
    tap(() => {
      deleteCredentials();
      pushRoute('/login');
    }),
    mapTo({ type: LOG_OUT })
  );

export default resetPasswordSuccess;
